export default {
	state: {
		serviceTypeCategories: []
	},

	actions: {
		getServiceTypeCategories(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "" +
						"stc.id, " +
						"stc.name";

					var tableName = "" +
						"@db.servicetypecategory stc";

					var filter = "" +
						"stc.inactive = 0";

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setServiceTypeCategories", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		setServiceTypeCategories(state, serviceTypeCategories) {
			state.serviceTypeCategories = serviceTypeCategories
		}
	},

	namespaced: true
}